/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ exercise: NonNullable<unknown> }} Plan_Suggestion_PlateauInputs */

const en_us2_plan_suggestion_plateau = /** @type {(inputs: Plan_Suggestion_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} has stalled. Let's swap it for a variation.`)
};

const pt_br2_plan_suggestion_plateau = /** @type {(inputs: Plan_Suggestion_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} está parado. Vamos trocar por uma variação.`)
};

const es_419_plan_suggestion_plateau = /** @type {(inputs: Plan_Suggestion_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} está estancado. Cambiémoslo por una variante.`)
};

const pt_pt2_plan_suggestion_plateau = /** @type {(inputs: Plan_Suggestion_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} estagnou. Vamos trocá-lo por uma variação.`)
};

const fr_fr2_plan_suggestion_plateau = /** @type {(inputs: Plan_Suggestion_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} stagne. Remplaçons-le par une variante.`)
};

const de_de2_plan_suggestion_plateau = /** @type {(inputs: Plan_Suggestion_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} stagniert. Tauschen wir sie gegen eine Variante.`)
};

const it_it2_plan_suggestion_plateau = /** @type {(inputs: Plan_Suggestion_PlateauInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} è in stallo. Sostituiamolo con una variante.`)
};

/**
* | output |
* | --- |
* | "{exercise} has stalled. Let's swap it for a variation." |
*
* @param {Plan_Suggestion_PlateauInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_suggestion_plateau = /** @type {((inputs: Plan_Suggestion_PlateauInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Suggestion_PlateauInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_suggestion_plateau(inputs)
	if (locale === "es-419") return es_419_plan_suggestion_plateau(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_suggestion_plateau(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_suggestion_plateau(inputs)
	if (locale === "de-DE") return de_de2_plan_suggestion_plateau(inputs)
	if (locale === "it-IT") return it_it2_plan_suggestion_plateau(inputs)
	return en_us2_plan_suggestion_plateau(inputs)
});
export { plan_suggestion_plateau as "plan.suggestion.plateau" }